import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const TextFieldBGGray = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: '#718096',
    fontSize: '14px',
    fontWeight: '500',
    transform: 'translate(14px, 12px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: 'white',
    padding: '0 4px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s',
    '& fieldset': {
      borderColor: '#e2e8f0',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: '#cbd5e0',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3182ce',
      borderWidth: '2px',
    },
    '& .MuiInputBase-input': {
      color: '#2d3748',
      fontSize: '15px',
      padding: '12px 14px',
    },
  },
});

export default TextFieldBGGray;
